import React, { FC, useRef } from 'react'
import makeStyles from '@mui/styles/makeStyles';

import LayoutCommandContext, {
  IData_Command_Context_Extractor,
  IData_Command_Context,
} from './CommandContext'

import {
  ILayout_Render_Context,
  ILayout,
} from '@kaidam/fc-shared/src/types/layout'

import Editor from './LayoutEditor'

import useLayoutRenderContext from '../hooks/useLayoutRenderContext'

import {
  LAYOUT_DEFAULT_DATA,
  LAYOUT_OPTIONS_FORM,
} from '@kaidam/fc-shared/src/constants'

const DEFAULT_PAGE_LAYOUT = Object.assign({}, LAYOUT_DEFAULT_DATA, {
  options: LAYOUT_OPTIONS_FORM,
})

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
}))

interface LayoutWrapperProps {
  data: ILayout,
  context?: ILayout_Render_Context,
  onChange: {
    (data: ILayout): void,
  }
}

const LayoutWrapper: FC<React.PropsWithChildren<LayoutWrapperProps>> = ({
  data,
  context,
  children,
  onChange,
}) => {

  const classes = useStyles()
  const layoutExtractorRef = useRef<IData_Command_Context_Extractor | null>(null)
  const baseRenderContext = useLayoutRenderContext()
  const renderContext = context || baseRenderContext
  const commandContext: IData_Command_Context = {
    setExtractor: (extractor) => {
      layoutExtractorRef.current = extractor
    },
    removeExtractor: () => layoutExtractorRef.current = null,
  }

  return (
    <LayoutCommandContext.Provider value={ commandContext }>
      <div className={ classes.root }>
        <Editor
          data={ data || DEFAULT_PAGE_LAYOUT }
          context={ renderContext }
          options={ LAYOUT_OPTIONS_FORM }
          onChange={ onChange }
          toolbarButtonsBefore={ children }
        />
      </div>
    </LayoutCommandContext.Provider>
  )
}

export default LayoutWrapper